module.exports = __webpack_public_path__ + "assets/img/bkhfx1.461f16e4.jpg";